import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import News from "components/Carousel/News";
import * as TextFormattin from "utils/TextFormattingUtils";
import HomeCard from "components/Card/HomeCard";
import { consultarSaldoCajaMenorEmisor } from "network/Api/SaldoDinero";
import Graph from "static/images/graph1.svg"
import Saldo from "static/images/saldo1.svg"
import SuSaldo from "static/images/susaldo1.svg"
import { UserOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import './index.css';

const style = () => ({
  cards: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
  },
  body: {},
  bodyRow: { display: "flex" },
});

function Home({ classes, userAttributes }) {
  const [state, setData] = useState({});

  const setState = (data) => setData((s) => ({ ...s, ...data }));

  useEffect(() => {
    if (userAttributes.codigoEmisor) {
      const { codigoEmisor } = userAttributes;
      consultarSaldoCajaMenorEmisor({ emisor: codigoEmisor }).then((res) =>
        setState({ cajaMenor: res.data, totalDocumentos: (res.data / userAttributes.cdTarifaDte).toFixed(0) })
      );
    }
  }, [userAttributes]);

  return (
    <>
      <Row style={{ padding: '26px' }}>
        <Col xxl={8} xl={8} lg={8} >
          <div style={{
            paddingTop: '43px',
            paddingBottom: '25px',
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            color: 'black'
          }}>
            <UserOutlined style={{
              display: "flex",
              justifyContent: 'center',
              fontSize: '114px',
              backgroundColor: 'gray',
              borderRadius: '50%',
              height: '96px',
              width: '100px',
              padding: '11px',
              color: 'white'
            }} />
            <div style={{ fontSize: '25px' }}>{userAttributes.nombresEmisor}</div>
          </div>
          <div style={{ justifyContent: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <HomeCard
                redirect="/recargar_saldo"
                title="Su saldo es:"
                content={`$ ${TextFormattin.decimalFormat(state.cajaMenor)}`}
                iconImg={SuSaldo}
                small={`Equivalen a ${TextFormattin.decimalFormat(state.totalDocumentos)} documentos`}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <HomeCard redirect="/historialcaja" content={`Mis Movimientos`} iconImg={Graph} fullHeigth={true} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <HomeCard redirect="/recargar_saldo" content={`Recargar Saldo`} iconImg={Saldo} fullHeigth={true} />
            </div>
          </div>
        </Col>
        <Col xxl={16} xl={16} lg={16} >
          <News />
        </Col>
      </Row>
    </>
  );
}

function mapStateToProps(state, _) {
  return { userAttributes: state.factura.userAttributes };
}

function mapDispatchToProps(_) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(Home));
